import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-codigos-promocion',
  templateUrl: './codigos-promocion.component.html',
  styleUrls: ['./codigos-promocion.component.scss']
})
export class CodigosPromocionComponent implements OnInit {

  isLoading = false;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pedido/codigos-promocion/codigos-promocion.component.ts